import './styles.scss'
import React, { useState } from 'react'
import { composerAct } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import HtmlEditorSmall from 'components/HtmlEditorSmall'
import AvatarImg from 'components/images/AvatarImg'
import { lang } from 'utils/helpers'

const ReplyEditor = ({ reaplyId, isOpenReplayEditor, setIsOpenReplayEditor, channel }) => {
  const dispatch = useDispatch()
  const [message, setMessage] = useState({})
  const company = useSelector(store => store.companies)
  const operator = useSelector(store => store.user)
  const options = channel === 'facebook_post' ? ['emojis', 'attachments'] : ['emojis']
  const [isSubmitting, setIsSubmitting] = useState(false)

  const sendComment = async () => {
    try {
      setIsSubmitting(true)
      await dispatch(composerAct.sendMessage(
        {
          message: message.valueHtml || ' ',
          attachments: message.attachments || [],
          checkTime: true,
          tag: null,
          buttons: null,
          vaSuggestion: null,
          nodeId: reaplyId,
          eventType: 'COMMENT',
        },
        null
      ))
      setIsOpenReplayEditor(false)
      setIsSubmitting(false)
    } catch (error) {
      console.error(error)
      setIsSubmitting(false)
    }

  }

  if (!isOpenReplayEditor) return null

  return (
    <div className='animated fadeIn answer-editor-container'>
      <div className='avatar'>
        <AvatarImg
          src={operator?.picture}
          className='avatar-img'
        />
      </div>
      <div className='answer-editor'>
        <HtmlEditorSmall
          channel={channel}
          id='answer'
          placeholder={lang('dashboard_write-message')}
          options={options}
          value=''
          onChange={(e) => {
            setMessage(e)
          }}
          minHeight={40}
          maxHeight={180}
          onClickButton={sendComment}
          company={company}
          disableEditor={isSubmitting}
        />
      </div>
    </div>
  )
}

export default ReplyEditor
